import React, { useCallback } from 'react';
import { Volume2 } from 'lucide-react';

interface AudioButtonProps {
  text: string;
  label?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/** TTS button using Web Speech API. Uses Tamil voice if available. */
export const AudioButton: React.FC<AudioButtonProps> = ({
  text,
  label,
  disabled,
  size = 'md',
  className = '',
}) => {
  const speak = useCallback(() => {
    if (!text || typeof window === 'undefined' || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'ta-IN';
    const voices = window.speechSynthesis.getVoices();
    const tamil = voices.find((v) => v.lang.startsWith('ta'));
    if (tamil) utterance.voice = tamil;
    window.speechSynthesis.speak(utterance);
  }, [text]);

  const sizeClass = size === 'sm' ? 'p-1.5 h-8 w-8' : 'p-2.5 h-10 w-10';
  const iconSize = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <button
      type="button"
      onClick={speak}
      disabled={disabled || !text}
      aria-label={label || `Play: ${text.slice(0, 30)}`}
      title={label || 'Play'}
      className={`inline-flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${sizeClass} ${className}`}
    >
      <Volume2 className={iconSize} />
    </button>
  );
};
